module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/pavia.4177c1beea5b5761bd92f5d9d987ff3d.jpg";